import React from 'react';
import { ExportContainerV2} from '../../Containers/ImportExportContainer';



const ExportV2 = (props) => {
	return (
		<ExportContainerV2 />
	);
}

export default ExportV2;